"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagSummaryStore = void 0;
const services_1 = require("../services");
const index_1 = require("./index");
class TagSummaryStore {
    getFetchable(tagId) {
        const rest = services_1.Services.Department.rest;
        const tag = index_1.AppStore.Tag.get(tagId);
        if (tag == null) {
            services_1.Services.Log.Logger.warn({ tagId }, 'Getting tag summary before tag');
            return rest.empty;
        }
        const fetchable = rest.Tag.Summary.getById(tag.objectId);
        if (fetchable.isFetching) {
            return fetchable;
        }
        if (fetchable.value == null) {
            return fetchable;
        }
        const fetchTime = Date.now() - fetchable.lastFetch;
        if (fetchTime < TagSummaryStore.REFETCH_DELAY) {
            return fetchable;
        }
        const tagUpdated = services_1.Services.DateTime.getTime(tag.updatedAt);
        if (tagUpdated < fetchable.lastFetch) {
            return fetchable;
        }
        // Looks like the tag summary is out of date force a refetch
        fetchable.refetch();
        return fetchable;
    }
    get(tagId) {
        return index_1.AppStore.TagSummary.getFetchable(tagId).value;
    }
    clear() {
        const rest = services_1.Services.Department.rest;
        if (rest != null) {
            rest.cache.clear(rest.Objects.TagSummary);
        }
    }
}
exports.TagSummaryStore = TagSummaryStore;
// Only refetch tag summaries at most once per 10 seconds.
TagSummaryStore.REFETCH_DELAY = 10000;
//# sourceMappingURL=tag.summary.store.js.map